import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../hooks/useMediaQuery';
import MapViewDesktop from './MapViewDesktop';
import MapViewMobile from './MapViewMobile';

// Main MapView component - renders Desktop or Mobile version based on screen size
function MapView() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [mounted, setMounted] = useState(false);

  // Ensure component is mounted before checking media query
  // This prevents hydration mismatch on SSR
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    // Return loading state while determining device type
    return (
      <div className="h-[500px] flex items-center justify-center bg-gradient-to-br from-amber-50 to-white rounded-2xl">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-amber-200 border-t-amber-500 rounded-full animate-spin mx-auto mb-3"></div>
          <p className="text-gray-500">{t('map.loading')}</p>
        </div>
      </div>
    );
  }

  // Render Mobile or Desktop version based on screen width
  return isMobile ? <MapViewMobile /> : <MapViewDesktop />;
}

export default MapView;
